export const CheckoutStepComponent = {
    template: `
        <oo-content>
            <oo-content-header>
                Checkout
            </oo-content-header>
            <oo-content-body class="content-padding">
                <form name="$ctrl.checkoutForm" ng-submit="$ctrl.checkout()">
                    <checkout-authenticated ng-if="$ctrl.AuthenticationService.isAuthenticated()"></checkout-authenticated>
                    <checkout-guest ng-if="!$ctrl.AuthenticationService.isAuthenticated()"></checkout-guest>
                    <oo-button id="button-checkout"
                            button-type="submit"
                            types="button-primary"
                            ng-if="!$ctrl.ResponsiveService.isMobile"
                            ng-click="$ctrl.handleErrors()"
                            is-loading="$ctrl.isLoading"
                            is-disabled="$ctrl.checkoutForm.$invalid || $ctrl.isLoading"
                            class="pull-right">
                            Place Order</oo-button>
                    <oo-card ng-if="$ctrl.ResponsiveService.isMobile">
                        <oo-card-body>
                            <read-only-cart summary="true"></read-only-cart>
                        </oo-card-body>
                    </oo-card>

                    <div class="column column-sm-12">
                        <p>
                            By placing an order you agree to our
                            <a href="https://pos.toasttab.com/terms-of-service" target="_blank">Terms of Service</a>
                            and <a href="https://pos.toasttab.com/privacy" target="_blank">Privacy Policy</a>
                        </p>
                    </div>

                    <div class="fixed-button-container" ng-if="$ctrl.ResponsiveService.isMobile">
                        <oo-button id="button-checkout"
                            types="checkout-button button button-full"
                            is-disabled="$ctrl.checkoutForm.$invalid || $ctrl.isLoading"
                            button-type="submit"
                            ng-click="$ctrl.handleErrors()"
                            is-loading="$ctrl.isLoading">
                            Place Order - {{$ctrl.paymentService.getTotalAmountForDisplay() | currency}}
                        </oo-button>
                    </div>
                </form>
            </oo-content-body>
        </oo-content>`,
    controller: class CheckoutStepComponent {
        constructor(
            $state,
            accountService,
            AuthenticationService,
            blockingCalloutService,
            cartDisplayService,
            cartService,
            checkoutService,
            errorMessageService,
            googleAnalyticsTrackingService,
            loyaltyService,
            orderInfoService,
            paymentService,
            promoCodeService,
            ResponsiveService,
            OUT_OF_STOCK_ERROR) {
            'ngInject';

            Object.assign(this, {
                $state,
                accountService,
                AuthenticationService,
                blockingCalloutService,
                cartDisplayService,
                cartService,
                checkoutService,
                data: accountService.data,
                errorMessageService,
                googleAnalyticsTrackingService,
                isLoading: false,
                loyaltyService,
                orderInfoService,
                paymentService,
                promoCodeService,
                ResponsiveService: ResponsiveService.data,
                OUT_OF_STOCK_ERROR
            });
        }

        $onInit() {
            this.cartService.getCart()
                .then(() => this.cartData = this.cartService.getCartData());

            this.accountService.getBasicInfo();

            // We don't need the loyalty config directly on this component, but we should
            // preload it in the background so that it is available by the time it may be
            // needed by the completeStepController.
            this.loyaltyService.getConfig();
        }

        checkout() {
            this.isLoading = true;
            this._finalizeAndPlaceOrder();
        }

        _finalizeAndPlaceOrder() {
            this.checkoutService.finalize()
                .then(
                    () => this._placeOrder(),
                    error => this._setOrderError(error)
                )
                .finally(() => this.isLoading = false);
        }

        _placeOrder() {
            this.isLoading = true;

            this.cartService.clearCartError();
            return this.orderInfoService.placeOrder({ retryFunction: () => this._placeOrder() })
                .then(() => this._resyncCart())
                .then(
                    () => this._finalizeOrder(),
                    error => this._setOrderError(error)
                )
                .finally(() => this.isLoading = false);
        }

        handleErrors() {
            const form = this.checkoutForm;
            if(form.$valid) return;

            form.$setSubmitted(true);
            this._submitForms(form.$error);
            this._displayErrorCallout(form.$error);
        }

        _submitForms(errors) {
            Object.keys(errors)
                .forEach(keyName => this._submitFormsHelper(errors[keyName], keyName));
        }

        _submitFormsHelper(errorList, key) {
            if(!errorList) return;
            if(!Array.isArray(errorList)) return;
            errorList.forEach(errorElement => this._submitSingleForm(errorElement, key));
        }

        _submitSingleForm(errorElement, key) {
            if(!errorElement) return;
            if(typeof errorElement.$setSubmitted === 'function') errorElement.$setSubmitted(true);
            if(errorElement.$error[key]) this._submitFormsHelper(errorElement.$error[key], key);
        }

        _displayErrorCallout(errorObject) {
            const errors = Object.keys(errorObject);
            const message = this.errorMessageService.getMessage(errors);
            this.blockingCalloutService.show(message);
        }

        _resyncCart() {
            this.googleAnalyticsTrackingService.trackPlaceOrder({
                isSuccess: true,
                hasLoyaltyRedemption: this.loyaltyService.isRedemptionApplied(),
                loyaltyRedemptionAmount: this.loyaltyService.getAppliedRedemptionAmount()
            });

            return this.cartService.resyncCart();
        }

        _finalizeOrder() {
            this.$state.go('complete');

            this.orderInfoService.clearTip();
            this.promoCodeService.clearAppliedCode();
            this.cartDisplayService.updateFulfillmentTimeFromCart();
        }

        _setOrderError(response = {}) {
            this.googleAnalyticsTrackingService.trackPlaceOrder({
                isSuccess: false,
                hasLoyaltyRedemption: this.loyaltyService.isRedemptionApplied(),
                loyaltyRedemptionAmount: this.loyaltyService.getAppliedRedemptionAmount()
            });

            if(this.OUT_OF_STOCK_ERROR === response.error) {
                this.cartService.setCartError(response);
            }
        }
    }
};
